import { render, staticRenderFns } from "./SendPush.vue?vue&type=template&id=4d80a7fe"
import script from "./SendPush.vue?vue&type=script&lang=js"
export * from "./SendPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports